module.exports = __webpack_public_path__ + "static/img/xiangganbianjie.125841d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/font/xiangganbianjie.png
// module id = w+dd
// module chunks = 1